import { accountFragment, chatInviteFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {Record} data
 * @param {string} data.personId
 */
export const createChatInvite = data =>
  makeRequest({
    operationName: 'CreateChatInvite',
    query: `
      mutation CreateChatInvite($data: ChatInviteCreateInput!) {
        createChatInvite(data: $data) {
          ...ChatInviteFragment
        }
      }
      
      ${chatInviteFragment}
      ${accountFragment}
    `,
    variables: { data },
  });

/**
 * @param {string} id
 */
export const deleteChatInvite = id =>
  makeRequest({
    operationName: 'DeleteChatInvite',
    query: `
      mutation DeleteChatInvite($id: String!) {
        deleteChatInvite(id: $id) {
          ...ChatInviteFragment
        }
      }
      
      ${chatInviteFragment}
      ${accountFragment}
    `,
    variables: { id },
  });
